export default __webpack_public_path__ + "static/media/image_error_bg.cdf0f630.jpg";